import { Sidebar } from "primereact/sidebar";

import commonStyle from "../content/CommonStyles.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useState } from "react";
import { Button } from "primereact/button";
import useApi from "../../Utils/BackendClient";
import DropdownInput from "./Inputs/DropdownInput";
import { DisplayErrors } from "../../Utils/ErrorHandler";
import TextInput from "./Inputs/TextInput";

const ExternalProductSidebarPicker = ({ sbVisible, onHide, onSelect, context, toast, cagent }) => {

    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState(null);
    const [productsLazyState, setProductsLazyState] = useState({
        first: 0,
        rows: 20,
        page: 1,
        filters: {
            cagent_id: { value: cagent, matchMode: 'equals' },
            name: { value: null, matchMode: 'contains' }
        }
    });
    const [productsTotalRecords, setProductsTotalRecords] = useState(null);
    const [showFilterMenu, setShowFilterMenu] = useState(true);

    const { fetchExternalProducts } = useApi();

    const getExternalProducts = async (state) => {
        console.log(state);
        const response = await fetchExternalProducts(state);

        if (response.status === 200) {
            setProductsTotalRecords(response.data.count);
            setProducts(response.data.results);
        }
        else {
            DisplayErrors(response.error, toast);
        }

        setLoading(false);
    }

    const onProductsPage = event => {
        event.page = event.page + 1;
        event.filters = productsLazyState.filters;
        getExternalProducts(event);
        setProductsLazyState(event);
    }

const setFilterValue = (param, value) => {
    setProductsLazyState(prev => ({
        ...prev,
        filters: {
            ...prev.filters,
            [param]: { ...prev.filters[param], value }
        }
    }));
};

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="text-xl text-900 font-bold">{tablename}</span>
            </div>
        );
    }

    const actionBodyTemplate = (rowData) => {

        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-plus"
                type="button"
                className={`p-button-rounded ${commonStyle.addButton}`}
                tooltip="Додати"
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => onSelect(rowData)}
            />
        </div>
        );
    };

    return (<Sidebar visible={sbVisible} onHide={onHide} position="right" className={commonStyle.sidebarTable}>
        {showFilterMenu && <>
            <DropdownInput
                value={productsLazyState.filters.cagent_id.value}
                context={context.enums.partners.data}
                onChange={(val) => setFilterValue("cagent_id", val)}
                label="Партнер"
                customStyle="w-full"
            />
            <TextInput
                value={productsLazyState.filters.name.value}
                setFunction={(val) => setFilterValue("name", val)}
                label="Назва товару"
                customStyle="w-full"
            />
        </>}
        <div className="flex flex-row mt-4">
            <Button icon={showFilterMenu ? "pi pi-arrow-up" : "pi pi-arrow-down"} label={showFilterMenu ? "Приховати фільтри" : "Показати фільтри"} severity="secondary" className="mr-2 w-full" outlined onClick={() => setShowFilterMenu(!showFilterMenu)} />
            {showFilterMenu && <Button label="Застосувати" severity="success" className="w-full" outlined onClick={() => getExternalProducts(productsLazyState)} />}
        </div>
        {(products && products?.length > 0) && <DataTable value={products} header={setTableHeader("Залишки партнерів")} className="mt-4" lazy
            rows={productsLazyState.rows} paginator onPage={onProductsPage} first={productsLazyState.first} loading={loading} totalRecords={productsTotalRecords} rowsPerPageOptions={[20, 50]}>
            <Column field="name" header="Назва продукту" />
            <Column field="quantity" header="К-сть" />
            <Column field="action" body={actionBodyTemplate} />
        </DataTable>}
    </Sidebar>);
};

export default ExternalProductSidebarPicker;